import { render, staticRenderFns } from "./GiftStatus.vue?vue&type=template&id=9539b90e&scoped=true&"
import script from "./GiftStatus.vue?vue&type=script&lang=ts&"
export * from "./GiftStatus.vue?vue&type=script&lang=ts&"
import style0 from "./GiftStatus.vue?vue&type=style&index=0&id=9539b90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9539b90e",
  null
  
)

export default component.exports